import React, { useState }  from 'react' ;
import { useTranslation} from 'react-i18next';
import EnvoiFormCB from '../../api/ContactezNous'

const Form = () => {

    const { t } = useTranslation() ;

    // const [cacheForm, setcacheForm] = useState(true)

    const [activForm, setactivForm] = useState(false) 
    const DisplayAlert = activForm && <p className="h1 text-danger"> Merci de remplir tous les champs </p> ;

    const [confirmEnvoi, setconfirmEnvoi] = useState(false) 
    const DisplayEnvoi = confirmEnvoi && <p className="h1 text-danger"> Votre Message à bien été envoyé, vous receverez une réponse sous 48H </p>;


    
        const [fName, setfName] = useState('')  
        const [Name , setName]  = useState('') 
        const [Text , setText]  = useState('')  
        const [Email, setEmail] = useState('')  
        const [Phone, setPhone] = useState('')
    

    return (

        <div>
            {/* {cacheForm && <div>hello</div>} */}
        <div>

            <div>
                <div className="row mb-2">

                    <div className="col">
                        <label htmlFor="FirstName">{t('Form.FirstName')}</label>
                        <input type="text" value={fName} id="FirstName" className="form-control" onChange={(event) => { setfName(event.target.value)}} />
                    </div>

                    <div className="col">
                        <label htmlFor="LastName">{t('Form.LastName')}</label>
                        <input type="text" value={Name} id="LastName" className="form-control"  onChange={(event) => { setName(event.target.value)}} /> 
                    </div>

                </div>

                            
                <div className="form-row">

                    <div className="form-group col-md-12">
                        <label htmlFor="inputEmail4">{t('Form.Email')}</label>
                        <input type="email" value={Email} className="form-control" placeholder="" id="inputEmail4"      onChange={(event) => { setEmail(event.target.value)}} />
                    </div>

                    <div className="form-group col-md-12">
                        <label htmlFor="inputPhone">Phone</label>
                        <input type="phone" value={Phone}  className="form-control" placeholder="" id="inputPhone"       onChange={(event) => { setPhone(event.target.value)}} /> 
                    </div>

                </div>


                <div className="form-group">
                    <label htmlFor="exampleFormControlTextarea1">{t('Form.text')}</label>
                    <textarea value={Text}  className="form-control" id="exampleFormControlTextarea1" rows="3"                    onChange={(event) => { setText(event.target.value)}}/>
                </div>
            </div>

            <button className="btn btn-danger"  type="submit" 
                onClick={async () => {
                if (Phone !== "" &&     fName !== "" &&       Name !== "" &&       Text !== "" &&    Email !== "") { //  si tout est rempli alors rentre ici 
                const result = await EnvoiFormCB(Phone, fName, Name, Text, Email)
                const resultStatus = JSON.parse(result)
                    if(resultStatus.status === "OK"){ // si l'api return que c'est envoyé alors fait ca 
                        console.log("if secondaire activé", resultStatus.status);
                        setactivForm(false) // efface la notif d'erreur
                        setconfirmEnvoi(true) // affiche que ca s'est bien envoyé
                        setfName('') 
                        setName('')
                        setText('') 
                        setEmail('') 
                        setPhone('') 
    
                        console.log('ouverture après execution des resets');


                    }
                   
                } else{ // dans le cas ou tout les paramètres n'ont pas été transmis affiche un message ou y'a marqué qu'il faut tout remplir

                    setactivForm(true)

                }
                }}  >

                {t('Form.Send')}
            </button>
                {DisplayAlert}
                {DisplayEnvoi}
            
        </div>
        </div>

    )
}

export default Form


// var cloudbackend = require('appdrag-cloudbackend'); 
// var appID = process.env.APPID; 
// var APIKey = process.env.APIKEY;
// var request = require('request');
// var zlib = require('zlib');
// cloudbackend.init(APIKey, appID);
// //---------------------------------------------------------
// exports.handler = async(event, context, callback) => {

//     var email = "neguedayinhara@gmail.com";
//     var fName = event["POST"]["fName"];
//     var phone = event["POST"]["phone"];
//     var Name = event["POST"]["Name"];
//     var emailClient = event["POST"]["emailClient"];
//     var messageCLient = event["POST"]["messageCLient"];

//     await cloudbackend.sqlSelect(`SELECT * FROM BDcontactezNous  `) 
//     .then(async function(response) {
//         var res = JSON.parse(response);
//         var table = res.Table;
//             var tableName = "BDcontactezNous";
//             var today= Date.now()
//             var columns = "fName, phone, Name, emailClient, messageCLient";
//             var values = `'${fName}', '${phone}', '${Name}', '${emailClient}','${messageCLient}' `; 
//             var query = "INSERT INTO " + tableName + " (" + columns + ") VALUES (" + values + ")"; 


//             await cloudbackend.sqlExecuteRawQuery(query)
//                 .then(async function(response) {
//                     var res = JSON.parse(response);
//                     console.log(res)
//                     var result = {};
//                     if (res.affectedRows == 1) {

//                         var from = "spirithacodesh@gmail.com";
//                         var sender = "My Website Admin";
//                         var subject = "Welcome and Please Confirm Your Email"
//                         var templateURL = "https://api.appdrag.com/NewsletterViewer.aspx?newsletterID=2754&appID=art-online-co-aeea04"; 
                        
                        
//                         var emailContent = await getTemplateContentFromUrl(templateURL); 
                       
//                             emailContent = emailContent.replace("[NAME]", Name);
//                             emailContent = emailContent.replace("[FNAME]", fName);
//                             emailContent = emailContent.replace("[PHONE]", phone);
//                             emailContent = emailContent.replace("[EMAILCLIENT]", emailClient);
//                             emailContent = emailContent.replace("[MESSAGECLIENT]", messageCLient);
//                             await cloudbackend.sendEmail(from, sender, email, subject, emailContent, true)
//                                 .then(function(response) {
//                                     console.log(response)
//                                 });


//                         result.success = "MailSend"
//                     } else {
//                         result.error = "Something went wrong!"
//                     } callback(null, result);  
//                 });
            
//     });

// };

// function getTemplateContentFromUrl(url) {
//         return new Promise( function(resolve, reject) {
//             request(url, {
//                 encoding: null
//             }, function(error, response, body) {
//                 if (!error && response.statusCode == 200) {
//                     if (response.headers['content-encoding'] == 'gzip') { 
//                         zlib.gunzip(body, function(err, dezipped) {
//                             emailContent = dezipped.toString();
//                             return resolve(emailContent);
//                         });
//                     } else {
//                         emailContent = body.toString();
//                         return resolve(emailContent);
//                     }
//                 } else {
//                     return resolve("ERROR: " + error);
//                 }
//             });
//         });
//     }
